import type { Transport } from "../core/transport.js";

export class IframeTransport implements Transport {
  private callbacks: Set<(data: unknown) => void> = new Set();
  private unlisten: (() => void) | null = null;

  constructor(private iframeRef: { current: HTMLIFrameElement | null }) {}

  send(message: unknown): void {
    const win = this.iframeRef.current?.contentWindow;
    if (win) {
      win.postMessage(
        typeof message === "string" ? message : JSON.stringify(message),
        "*"
      );
    }
  }

  onMessage(cb: (data: unknown) => void): () => void {
    this.callbacks.add(cb);
    if (!this.unlisten) {
      const listener = (e: MessageEvent) => {
        for (const c of this.callbacks) {
          c(e.data);
        }
      };
      if (typeof window !== "undefined") {
        window.addEventListener("message", listener);
        this.unlisten = () => window.removeEventListener("message", listener);
      }
    }
    return () => {
      this.callbacks.delete(cb);
      if (this.callbacks.size === 0 && this.unlisten) {
        this.unlisten();
        this.unlisten = null;
      }
    };
  }
}
